import { ButtonType } from '@getaccept/fried-tofu';
import { SignatureConstants } from '@getaccept/lib-shared-new/src/signature/constants/signature.constants';
import { SignatureHelper } from '@getaccept/lib-shared-new/src/helpers/signature.helper';
import { useI18n } from 'vue-i18n';
import { defineComponent, computed, ref } from 'vue';
export default defineComponent({
    props: {
        height: {
            type: String,
            default: SignatureConstants.drawSignatureHeight,
        },
        width: {
            type: String,
            default: SignatureConstants.drawSignatureWidth,
        },
        saveType: {
            type: String,
            default: SignatureConstants.saveType,
        },
    },
    emits: ['reset', 'signature'],
    setup(_, { emit }) {
        const { t } = useI18n();
        const showInfoText = ref(true);
        const signaturePad = ref(null);
        const showInfoTextSection = computed(() => showInfoText.value);
        const hideText = () => {
            showInfoText.value = false;
        };
        const reset = () => {
            if (!signaturePad.value) {
                return;
            }
            signaturePad.value.clearSignature();
            emit('reset');
        };
        const undo = () => {
            signaturePad.value.undoSignature();
            setSignature();
        };
        const setSignature = () => {
            const rawData = signaturePad.value.toData() || [];
            const jSignature = SignatureHelper.signPadNativeToJSignature(rawData);
            const signatureBase30 = SignatureHelper.nativeToBase30(jSignature);
            const { isEmpty, data } = signaturePad.value.saveSignature('image/svg+xml');
            if (!!signatureBase30 && !isEmpty) {
                emit('signature', { signatureBase30, signatureBase64: data });
            }
            else {
                reset();
            }
        };
        const options = {
            penColor: SignatureConstants.writeSignatureColor,
            onEnd: setSignature,
            onBegin: hideText,
            backgroundColor: SignatureConstants.writeSignatureBackgroundColor,
        };
        return {
            t,
            ButtonType,
            signaturePad,
            options,
            undo,
            setSignature,
            reset,
            hideText,
            showInfoTextSection,
            showInfoText,
        };
    },
});
